export default __webpack_public_path__ + "static/media/kraken.0c2323bf.png";